'use client';
import * as React from 'react';
import { MentimeterLogoType } from '@mentimeter/ragnar-visuals';
import { useTranslations } from 'next-intl';
import { Box } from '@mentimeter/ragnar-ui/box';
import { NavLink } from '../../Header/NavLink';
import { Section, Wide } from '../../Layout';

const DefaultFooterItems = () => {
  const t = useTranslations('first_impression.legacy.common');
  return [
    {
      children: t('page_links.legal'),
      href: '/trust',
    },
    {
      children: t('page_links.policies'),
      href: '/trust/legal/privacy-policy',
    },
  ];
};

export const FooterSlim = () => {
  const translations = DefaultFooterItems();
  return (
    <Section
      theme={{ colors: 'plain' }}
      as="footer"
      justifyContent="center"
      bg="bg"
      py="space4"
    >
      <Wide flexDirection={['column', 'row', 'row']} mx="auto">
        <Box
          width={['100%', 1 / 6, 1 / 6]}
          my={['space8', 'space0']}
          alignItems="flex-start"
        >
          <Box
            width={['170px', '120px', null, '170px']}
            height={['23px', '15px', null, '23px']}
          >
            <MentimeterLogoType />
          </Box>
        </Box>
        <Box
          flexDirection={['column', 'row', 'row']}
          width={['100%', 4 / 6]}
          justifyContent="center"
          mb={['space8', 'space0', null]}
        >
          {translations.map(({ children, href, ...rest }) => (
            <Box key={href} mb={['space4', 'space0', null]}>
              <Box width="100%">
                <NavLink
                  {...rest}
                  mx="space8"
                  color="textWeak"
                  underline={false}
                  href={href}
                >
                  {children}
                </NavLink>
              </Box>
            </Box>
          ))}
        </Box>
      </Wide>
    </Section>
  );
};
